import React from 'react';
import { Grid } from '@material-ui/core';
import { DashboardHeader } from 'shared_elements';
import RoleplaysDashboardsList from '../RoleplaysDashboardList/RoleplaysDashboardsList';
import RoleplayProgress from '../RoleplayProgress/RoleplayProgress';
import History from '../History/History';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import MyTeam from '../MyTeam/MyTeam';
import logo from 'assets/roleplay/roleplay_logo.svg';
import DateTime from 'infrastructure/Datetime';
import AssignRealPlayDataHelper from 'features/realplays/AssignRealPlayData.helper';
import {
  useShouldShowRealPlaysModal,
  useShouldManagerOptionInModal,
} from 'features/realplays/RealPlaysHook';
import NewAssignRoleplay from '../AsignRoleplay/NewAssignRoleplay';
import { useGetFF } from '@fstack-tech/ff_react_module';

const RoleplayContainer = () => {
  const { active } = useShouldShowRealPlaysModal();
  const { managerOption } = useShouldManagerOptionInModal();
  const { isEnabled: version } = useGetFF({ flag_id: 'realplays_endpoints' });

  const close = useRoleplayStore((state) => state?.closeAssignModal);
  const setFormDataAssignRoleplay = useRoleplayStore((state) => state?.setFormDataAssignRoleplay);
  const assignModal = useRoleplayStore((state) => state?.assignModalOpen);

  const { reset } = AssignRealPlayDataHelper();

  const handleClose = () => {
    setFormDataAssignRoleplay({
      scenarios: [],
      deadline: DateTime.formatDate(new Date()) + ' 00:00:00',
    });
    reset();
    close();
  };

  return (
    <>
      <DashboardHeader dashboardLogo={logo} title="Roleplay" isRoleplayPage={true} />
      {assignModal && (
        <NewAssignRoleplay
          open={assignModal}
          handleClose={handleClose}
          active={active}
          managerOption={managerOption}
          version={version}
        />
      )}
      <RoleplaysDashboardsList active={active} />
      <Grid container spacing={4} style={{ margin: '2rem -16px -8px -16px' }}>
        <Grid item xs={12} md={6} style={{ paddingTop: '1rem' }}>
          <RoleplayProgress />
        </Grid>
        <Grid item xs={12} md={6} style={{ paddingTop: 0 }}></Grid>
      </Grid>
      <History />
      <MyTeam />
    </>
  );
};

export default RoleplayContainer;
